<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M338 487 c-7 -8 -29 -37 -48 -65 -32 -47 -38 -52 -75 -52 -39 0 -106
-28 -112 -46 -5 -14 213 -227 225 -220 18 11 42 74 42 113 0 36 4 41 65 82 36
24 65 49 65 55 0 12 -131 146 -142 146 -4 0 -13 -6 -20 -13z"
      />
      <path
        d="M84 120 c-118 -149 -114 -156 26 -44 52 41 98 79 103 83 4 4 -6 19
-21 34 l-29 27 -79 -100z"
      />
    </g>
  </svg>
</template>
